"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
Object.defineProperty(exports, "__esModule", { value: true });
var common_1 = require("@angular/common");
var core_1 = require("@angular/core");
/**
 * This class is deprecated, and will no longer be supported.
 * @deprecated since 3.16.0
 */
var CookieService = /** @class */ (function () {
    // tslint:disable-next-line:no-any
    function CookieService(document) {
        this.document = document;
    }
    CookieService_1 = CookieService;
    /**
     * @param name Cookie name
     * @returns {RegExp}
     */
    CookieService.getCookieRegExp = function (name) {
        var escapedName = name.replace(/([\[\]{}()|=;+?,.*^$])/gi, '\\$1');
        return new RegExp('(?:^' + escapedName + '|;\\s*' + escapedName + ')=(.*?)(?:;|$)', 'g');
    };
    /**
     * @param name Cookie name
     * @returns {boolean}
     */
    CookieService.prototype.check = function (name) {
        if (this.document === undefined) {
            return false;
        }
        name = encodeURIComponent(name);
        return CookieService_1.getCookieRegExp(name).test(this.document.cookie);
    };
    /**
     * @param name Cookie name
     * @returns {string}
     */
    CookieService.prototype.get = function (name) {
        if (this.document === undefined || !this.check(name)) {
            return '';
        }
        return decodeURIComponent(CookieService_1.getCookieRegExp(encodeURIComponent(name)).exec(this.document.cookie)[1]);
    };
    CookieService.prototype.getAll = function () {
        if (this.document === undefined) {
            return {};
        }
        var cookies = {};
        if (this.document.cookie) {
            this.document.cookie.split(';').forEach(function (cookie) {
                var _a = cookie.split('='), key = _a[0], value = _a[1];
                cookies[decodeURIComponent(key.replace(/^ /, ''))] = decodeURIComponent(value);
            });
        }
        return cookies;
    };
    /**
     * @param name    Cookie name
     * @param value   Cookie value
     * @param expires Number of days until the cookies expires or an actual `Date`
     * @param path    Cookie path
     * @param domain  Cookie domain
     * @param secure  Secure flag
     */
    CookieService.prototype.set = function (name, value, expires, path, domain, secure) {
        if (this.document === undefined) {
            return;
        }
        var cookieString = encodeURIComponent(name) + '=' + encodeURIComponent(value) + ';';
        if (expires) {
            if (typeof expires === 'number') {
                var dateExpires = new Date(new Date().getTime() + expires * 1000 * 60 * 60 * 24);
                cookieString += 'expires=' + dateExpires.toUTCString() + ';';
            }
            else {
                cookieString += 'expires=' + expires.toUTCString() + ';';
            }
        }
        if (path) {
            cookieString += 'path=' + path + ';';
        }
        if (domain) {
            cookieString += 'domain=' + domain + ';';
        }
        if (secure) {
            cookieString += 'secure;';
        }
        this.document.cookie = cookieString;
    };
    /**
     * @param name   Cookie name
     * @param path   Cookie path
     * @param domain Cookie domain
     */
    CookieService.prototype.delete = function (name, path, domain) {
        if (this.document === undefined) {
            return;
        }
        this.set(name, '', -1, path, domain);
    };
    /**
     * @param path   Cookie path
     * @param domain Cookie domain
     */
    CookieService.prototype.deleteAll = function (path, domain) {
        if (this.document === undefined) {
            return;
        }
        var cookies = this.getAll();
        for (var cookieName in cookies) {
            if (cookies.hasOwnProperty(cookieName)) {
                this.delete(cookieName, path, domain);
            }
        }
    };
    CookieService = CookieService_1 = __decorate([
        core_1.Injectable(),
        __param(0, core_1.Inject(common_1.DOCUMENT)),
        __metadata("design:paramtypes", [Object])
    ], CookieService);
    return CookieService;
    var CookieService_1;
}());
exports.CookieService = CookieService;
//# sourceMappingURL=cookie-service.js.map